var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56719 7.30322L7.60312 10.4907H10.9547L8.24531 12.4642L9.28125 15.6517L6.56719 13.6829L3.85313 15.6517L4.89375 12.4642L2.17969 10.4907H5.53125L6.56719 7.30322Z",
    fill: "#FFDA44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2265 18.586L13.4343 17.611L12.2624 18.0657L12.9421 17.011L12.1499 16.0313L13.364 16.3547L14.0483 15.3L14.114 16.5563L15.3327 16.8797L14.1561 17.3297L14.2265 18.586Z",
    fill: "#FFDA44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8015 15.7266L16.1765 14.5266L15.1499 13.8L16.4062 13.7813L16.7765 12.5813L17.1843 13.7719L18.4405 13.7579L17.4327 14.5079L17.8358 15.6985L16.8093 14.9719L15.8015 15.7266Z",
    fill: "#FFDA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9251 8.80771L17.372 9.9374L18.272 10.814L17.0298 10.6358L16.4767 11.7608L16.261 10.5233L15.0142 10.3452L16.1298 9.75928L15.9142 8.51709L16.8142 9.39365L17.9251 8.80771Z",
    fill: "#FFDA44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2597 5.38599L14.1659 6.63755L15.3331 7.11099L14.1097 7.41099L14.0206 8.66724L13.3597 7.59849L12.1362 7.89849L12.9472 6.93755L12.2815 5.87349L13.4487 6.34692L14.2597 5.38599Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.9106bfeaebd3671394da2881bb64dcdc.svg";
export { ForwardRef as ReactComponent };